import React from "react";
import Slider from "react-slick";
import { carouselConfigMobile, carouselConfigWeb } from "@stadium/constants";
import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { appendBackgroundImage } from "@sendmagic/prismic-nextjs/src/helpers/images";

import SmQuoteImg from "@sendmagic/prismic-nextjs/src/assets/images/quote.png";

const BlockQuote = ({ type = "start", className = "", quoteImage }) => (
  <Multimedia
    type="image"
    src={quoteImage?.url || SmQuoteImg}
    className={`quote-image ${type === "start" ? "quote-start" : "quote-close"} ${className}`}
    alt="quote"
    isNextImage={false}
  />
);

const responseSliderSettings = [
  {
    breakpoint: 992,
    settings: {
      ...carouselConfigMobile,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      touchMove: true,
      swipeToSlide: true,
    },
  },
  {
    breakpoint: 767,
    settings: {
      ...carouselConfigMobile,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      touchMove: true,
      swipeToSlide: true,
    },
  },
];

const carouselConfig = {
  ...carouselConfigWeb,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  responsive: responseSliderSettings,
  touchMove: true,
};

const Testimonial = ({ content, author, company, image, quote_image }) => {
  const isCustomerNamePresent = checkContentPresence(author);
  const isCustomerCompanyNamePresent = checkContentPresence(company);
  const sectionStyle = appendBackgroundImage(image?.url);
  return (
    <div className="customer-testimonial-block-container" style={sectionStyle}>
      <div className="ls-57 lh-1-point-7 d-flex customer-testimonial-block-border justify-content-between flex-column">
        <div className="customer-testimonial-content">
          <div className="mb-4">
            <BlockQuote quoteImage={quote_image} />
          </div>
          <div className="px-3 testimonial-content">{textResolver(content)}</div>
        </div>
        <div className="mt-2 customer-testimonials-border">
          {(isCustomerNamePresent || isCustomerCompanyNamePresent) && (
            <div className="user-name my-4 px-3">
              <div className="author_cl">
                <span className="hyphen">-</span> {textResolver(author)}
              </div>
              {isCustomerNamePresent && isCustomerCompanyNamePresent}
              <div className="company_cl">{textResolver(company)}</div>
            </div>
          )}
          <BlockQuote quoteImage={quote_image} type="end" className="ml-auto" />
        </div>
      </div>
    </div>
  );
};

const CustomerTestimonialSlider = ({ doc }) => {
  const { title, internal_link_id, slider_flag, link, link_text } = doc?.primary || {};
  const items = doc?.items || [];
  return (
    <div className="customer-testimonials pt-5 pb-3 pb-md-5 prismic-slice">
      <div className="container-full customer-testimonial-container container-width container-2xl">
        {internal_link_id && (
          <span id={internal_link_id} className="scroll-point position-relative d-block" />
        )}
        {!!checkContentPresence(title) && (
          <div className="sns-h2 navy-blue text-center customer-testimonial-title clr_g same-size-title">
            {textResolver(title)}
          </div>
        )}
        {slider_flag ? (
          <div className="product-tile-carousel mt-5">
            <Slider {...carouselConfig}>
              {items.map((testimonial, idx) => (
                <Testimonial key={`customer-testimonial-${idx}`} {...testimonial} />
              ))}
            </Slider>
          </div>
        ) : (
          <div className="container">
            <div className="mt-5 customer-testimonial-row">
              {items.map((testimonial, idx) => (
                <Testimonial key={`customer-testimonial-${idx}`} {...testimonial} />
              ))}
            </div>
          </div>
        )}
        {link?.url && (
          <div className="mt-2 text-center font-weight-bold customer-testimonial-footer-link-row">
            <PrismicLinkTag
              urlText={link_text}
              url={link?.url}
              target={link?.target}
              className="font-weight-bold cta-green-18 text-uppercase program-link"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerTestimonialSlider;
